<template>
  <div
    v-if="show && wildfire"
    class="customer-popup-overlay"
    @click.self="$emit('close')"
  >
    <div class="customer-popup-content">
      <!-- Header -->
      <div class="customer-popup-header">
        <div>
          <h3 class="customer-popup-title">{{ wildfire.fire_name || 'Unnamed Fire' }}</h3>
          <p class="customer-popup-subtitle">Wildfire Details</p>
        </div>
        <button @click="$emit('close')" class="customer-popup-close" aria-label="Close">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      
      <!-- Body -->
      <div class="customer-popup-body">
        <!-- Fire Information -->
        <div class="customer-popup-section">
          <h4 class="customer-popup-section-title">Fire Information</h4>
          
          <div v-if="wildfire.initial_imsr_date" class="customer-popup-data-row">
            <div class="customer-popup-label">Date Detected:</div>
            <div class="customer-popup-value">{{ formatDate(wildfire.initial_imsr_date) }}</div>
          </div>
          
          <div v-if="wildfire.size" class="customer-popup-data-row">
            <div class="customer-popup-label">Size:</div>
            <div class="customer-popup-value">{{ formatSize(wildfire.size) }}</div>
          </div>
          
        </div>

        
        <!-- Management Information -->
        <div v-if="wildfire.imt_type" class="customer-popup-section">
          <h4 class="customer-popup-section-title">Management</h4>
          
          <div class="customer-popup-data-row">
            <div class="customer-popup-label">Incident Management Team:</div>
            <div class="customer-popup-value">Type {{ wildfire.imt_type }}</div>
          </div>
        </div>
      </div>
      
      <!-- Footer -->
      <div class="customer-popup-footer">
        <button @click="$emit('close')" class="customer-popup-button">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WildfirePopup',
  
  props: {
    wildfire: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    document.addEventListener('keydown', this.handleEscKey);
  },
  
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKey);
  },
  
  methods: {
    handleEscKey(event) {
      if (event.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      
      try {
        // Parse date string like "Thu, 19 Jun 2025 00:00:00 GMT"
        const date = new Date(dateString);
        
        if (isNaN(date.getTime())) return dateString;
        
        // Format as "June 19, 2025"
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      } catch (error) {
        return dateString;
      }
    },
    
    formatSize(size) {
      if (size === null || size === undefined) return 'N/A';
      
      // Format with commas and add "acres"
      const formattedNumber = parseFloat(size).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      
      return `${formattedNumber} acres`;
    },
    
    formatCoordinates(lat, lon) {
      if (lat === null || lat === undefined || lon === null || lon === undefined) {
        return 'N/A';
      }
      
      // Format latitude with N/S
      const latDir = lat >= 0 ? 'N' : 'S';
      const latFormatted = `${Math.abs(lat).toFixed(4)}°${latDir}`;
      
      // Format longitude with E/W
      const lonDir = lon >= 0 ? 'E' : 'W';
      const lonFormatted = `${Math.abs(lon).toFixed(4)}°${lonDir}`;
      
      return `${latFormatted}, ${lonFormatted}`;
    }
  }
};
</script>
